import React from 'react';

const AlumniDetailModal = ({ alumni, onClose }) => {
  // Add default values for missing fields
  const alumniData = {
    emp_empname: alumni.emp_empname || 'Unknown',
    emp_empcode: alumni.emp_empcode || 'N/A',
    emp_email: alumni.emp_email || 'N/A',
    emp_dateofbirth: alumni.emp_dateofbirth || 'N/A',
    emp_sex: alumni.emp_sex || 'N/A',
    emp_race: alumni.emp_race || 'N/A',
    emp_country: alumni.emp_country || 'N/A',
    emp_maritalstatus: alumni.emp_maritalstatus || 'N/A',
    emp_imm_status: alumni.emp_imm_status || 'N/A',
    emp_startdate: alumni.emp_startdate || 'N/A',
    emp_enddate: alumni.emp_enddate || 'N/A',
    emp_cellphone: alumni.emp_cellphone || 'N/A',
    emp_homephone: alumni.emp_homephone || 'N/A',
    emp_workphone: alumni.emp_workphone || 'N/A',
    emp_address1: alumni.emp_address1 || 'N/A',
    emp_address2: alumni.emp_address2 || '',
    emp_address3: alumni.emp_address3 || '',
    emp_address4: alumni.emp_address4 || '',
    currentTitle: alumni.currentTitle || 'Former Dynpro Employee',
    currentCompany: alumni.currentCompany || 'N/A',
    linkedInUrl: alumni.linkedInUrl || ''
  };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto border border-gray-200 transform transition-all duration-300 ease-in-out">
        {/* Header */}
        <div className="bg-gradient-to-r from-primary to-blue-700 text-white px-8 py-5 rounded-t-xl flex justify-between items-center">
          <div className="flex items-center">
            <div className="w-12 h-12 rounded-full bg-white text-primary flex items-center justify-center mr-4 font-bold text-xl shadow-md">
              {alumniData.emp_empname.charAt(0)}
            </div>
            <div>
              <h2 className="text-2xl font-bold">{alumniData.emp_empname}</h2>
              <p className="text-blue-100 text-sm">{alumniData.currentTitle}</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="text-white hover:text-gray-200 bg-blue-800 bg-opacity-30 rounded-full p-2 transition-colors duration-200 hover:bg-opacity-50"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        {/* Content */}
        <div className="p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Left Column - CSV Data */}
            <div className="bg-gray-50 rounded-xl p-6 shadow-inner">
              <h3 className="text-xl font-semibold mb-6 text-primary border-b border-blue-200 pb-2 flex items-center">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"></path>
                </svg>
                Employee Information
              </h3>
              
              <div className="space-y-6">
                <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                  <h4 className="font-medium text-blue-700 mb-3 flex items-center">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm2.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.45 4a2.5 2.5 0 10-4.9 0h4.9zM12 9a1 1 0 100 2h3a1 1 0 100-2h-3zm-1 4a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z" clipRule="evenodd"></path>
                    </svg>
                    Personal Details
                  </h4>
                  <div className="grid grid-cols-2 gap-3 mt-2">
                    <div className="text-sm font-medium text-gray-600">Employee ID:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">{alumniData.emp_empcode}</div>
                    
                    <div className="text-sm font-medium text-gray-600">Date of Birth:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">{alumniData.emp_dateofbirth}</div>
                    
                    <div className="text-sm font-medium text-gray-600">Gender:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">{alumniData.emp_sex}</div>
                    
                    <div className="text-sm font-medium text-gray-600">Race:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">{alumniData.emp_race}</div>
                    
                    <div className="text-sm font-medium text-gray-600">Country:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">{alumniData.emp_country}</div>
                    
                    <div className="text-sm font-medium text-gray-600">Marital Status:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">{alumniData.emp_maritalstatus}</div>
                    
                    <div className="text-sm font-medium text-gray-600">Immigration Status:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">{alumniData.emp_imm_status}</div>
                  </div>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                  <h4 className="font-medium text-blue-700 mb-3 flex items-center">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"></path>
                    </svg>
                    Employment History
                  </h4>
                  <div className="grid grid-cols-2 gap-3 mt-2">
                    <div className="text-sm font-medium text-gray-600">Start Date:</div>
                    <div className="text-sm bg-green-50 text-green-700 px-2 py-1 rounded font-medium">{alumniData.emp_startdate}</div>
                    
                    <div className="text-sm font-medium text-gray-600">End Date:</div>
                    <div className="text-sm bg-red-50 text-red-700 px-2 py-1 rounded font-medium">{alumniData.emp_enddate}</div>
                  </div>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                  <h4 className="font-medium text-blue-700 mb-3 flex items-center">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
                    </svg>
                    Contact Information
                  </h4>
                  <div className="grid grid-cols-2 gap-3 mt-2">
                    <div className="text-sm font-medium text-gray-600">Email:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded overflow-hidden text-ellipsis">
                      <a href={`mailto:${alumniData.emp_email}`} className="text-blue-600 hover:underline">{alumniData.emp_email}</a>
                    </div>
                    
                    <div className="text-sm font-medium text-gray-600">Cell Phone:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">
                      <a href={`tel:${alumniData.emp_cellphone}`} className="text-blue-600 hover:underline">{alumniData.emp_cellphone}</a>
                    </div>
                    
                    <div className="text-sm font-medium text-gray-600">Home Phone:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">
                      <a href={`tel:${alumniData.emp_homephone}`} className="text-blue-600 hover:underline">{alumniData.emp_homephone}</a>
                    </div>
                    
                    <div className="text-sm font-medium text-gray-600">Work Phone:</div>
                    <div className="text-sm bg-blue-50 px-2 py-1 rounded">
                      <a href={`tel:${alumniData.emp_workphone}`} className="text-blue-600 hover:underline">{alumniData.emp_workphone}</a>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                  <h4 className="font-medium text-blue-700 mb-3 flex items-center">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"></path>
                    </svg>
                    Address
                  </h4>
                  <div className="mt-2 text-sm bg-blue-50 p-3 rounded border-l-4 border-blue-400">
                    <p>{alumniData.emp_address1}</p>
                    {alumniData.emp_address2 && <p>{alumniData.emp_address2}</p>}
                    {alumniData.emp_address3 && <p>{alumniData.emp_address3}</p>}
                    {alumniData.emp_address4 && <p>{alumniData.emp_address4}</p>}
                  </div>
                </div>
              </div>
            </div>
            
            {/* Right Column - LinkedIn Data */}
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-200">
              <h3 className="text-xl font-semibold mb-6 text-primary border-b border-blue-200 pb-2 flex items-center">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
                LinkedIn Information
              </h3>
              
              {alumniData.linkedInUrl ? (
                <div className="space-y-6">
                  <div className="bg-gradient-to-r from-blue-50 to-white p-5 rounded-lg border border-blue-100 shadow-sm">
                    <h4 className="font-medium text-blue-700 mb-4 flex items-center">
                      <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z" clipRule="evenodd"></path>
                        <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z"></path>
                      </svg>
                      Current Position
                    </h4>
                    <div className="flex flex-col space-y-4">
                      <div className="flex items-center">
                        <div className="w-24 text-sm font-medium text-gray-600">Title:</div>
                        <div className="text-lg font-semibold text-blue-800 bg-blue-50 px-4 py-2 rounded-lg flex-1">
                          {alumniData.currentTitle}
                        </div>
                      </div>
                      
                      <div className="flex items-center">
                        <div className="w-24 text-sm font-medium text-gray-600">Company:</div>
                        <div className="text-lg font-semibold text-blue-800 bg-blue-50 px-4 py-2 rounded-lg flex-1">
                          {alumniData.currentCompany}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <a 
                      href={alumniData.linkedInUrl} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-md"
                    >
                      <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                      </svg>
                      View Complete Profile
                    </a>
                    
                    <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg font-medium">
                      Last Updated: {new Date().toLocaleDateString()}
                    </div>
                  </div>
                  
                  <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-6 rounded-lg mt-4 text-white shadow-lg">
                    <h4 className="font-medium text-white mb-4 flex items-center text-lg">
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" clipRule="evenodd"></path>
                      </svg>
                      Leadership Potential
                    </h4>
                    <div className="flex flex-col space-y-4">
                      <div className="flex items-center">
                        <div className="w-full bg-blue-300 bg-opacity-30 rounded-full h-4">
                          <div 
                            className="bg-white h-4 rounded-full" 
                            style={{ width: `${Math.floor(Math.random() * 40) + 60}%` }}
                          ></div>
                        </div>
                        <span className="ml-3 text-sm font-bold bg-white text-blue-700 px-3 py-1 rounded-full">High</span>
                      </div>
                      <p className="text-blue-100 mt-2">
                        Based on current position and career progression, this alumni has a high leadership score,
                        making them an excellent campaign candidate. Consider reaching out for executive engagement opportunities.
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-gray-50 p-8 rounded-lg text-center shadow-inner border border-gray-200">
                  <svg className="w-20 h-20 mx-auto text-gray-300 mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                  </svg>
                  <h4 className="text-xl font-medium text-gray-700 mb-3">LinkedIn Data Not Available</h4>
                  <p className="text-gray-500 mb-6 max-w-md mx-auto">
                    No LinkedIn information has been found for this alumni yet. Use the "Search LinkedIn" button to find their professional profile.
                  </p>
                  <button 
                    className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 shadow-md flex items-center mx-auto"
                    onClick={onClose}
                  >
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd"></path>
                    </svg>
                    Return to Alumni List
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        
        {/* Footer */}
        <div className="bg-gray-50 px-8 py-5 rounded-b-xl flex justify-between items-center border-t border-gray-200">
          <div className="text-sm text-gray-500">
            <span className="font-medium">Employee ID:</span> {alumni.emp_empcode}
          </div>
          <div className="flex space-x-3">
            <button 
              onClick={onClose}
              className="bg-gray-200 text-gray-700 px-5 py-2 rounded-lg hover:bg-gray-300 transition-colors duration-200 flex items-center font-medium"
            >
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
              </svg>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlumniDetailModal;
